

































































import { Component, Mixins } from 'vue-property-decorator';

import MyList from '@/mixins/list';

@Component
export default class extends Mixins(MyList) {
    dispatchType = 'bi/reportList'

    columns: any[] = [
      { title: '编号', dataIndex: 'id' },
      { title: '类别', scopedSlots: { customRender: 'type' } },
      { title: '月份', dataIndex: 'month' },
      { title: '操作', scopedSlots: { customRender: 'action' } },
    ]

    mounted() {
      this.loadData();
    }
}
